import { render } from "./examination-information.vue?vue&type=template&id=667c2bc5"
import script from "./examination-information.vue?vue&type=script&lang=js"
export * from "./examination-information.vue?vue&type=script&lang=js"

import "./examination-information.vue?vue&type=style&index=0&id=667c2bc5&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__